module.exports = __webpack_public_path__ + "img/ic_back.2a8c1f34.svg";